import React, { forwardRef, useRef } from 'react';
import Box from '@mui/material/Box';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

export const LoadingTransition = ({
  isLoading,
  loading = true,
  content,
  speed = 200,
}: LoadingTransitionProps) => {
  const nodeRef = useRef(null);
  return (
    <SwitchTransition>
      <CSSTransition
        key={isLoading ? 'loading' : 'content'}
        nodeRef={nodeRef}
        timeout={speed * 2}
        classNames='fade'
        unmountOnExit
      >
        <Box
          ref={nodeRef}
          sx={{
            display: 'inherit',
            flexDirection: 'inherit',
            gap: 'inherit',
            alignItems: 'inherit',
            justifyContent: 'inherit',
            width: '100%',
            height: '100%',
            '&.fade-enter': { opacity: 0 },
            '&.fade-enter-active': {
              opacity: 1,
              transitionDuration: `${speed}ms`,
            },
            '&.fade-exit': { opacity: 1 },
            '&.fade-exit-active': {
              opacity: 0,
              transitionDuration: `${speed}ms`,
              transitionDelay: '100ms',
            },
          }}
        >
          {isLoading ? loading : content}
        </Box>
      </CSSTransition>
    </SwitchTransition>
  );
};

interface LoadingTransitionProps {
  isLoading?: boolean;
  loading: React.ReactNode;
  content: React.ReactNode;
  speed?: number;
}

LoadingTransition.displayName = 'LoadingTransition';

export default LoadingTransition;
